module.exports = __webpack_public_path__ + "static/media/BG01.637f21ad.png";